// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"1589c98e","415":"9887daa1","446":"2717e3b0","563":"fe426b78","608":"7d29f7ed","650":"b568fbdf"}[chunkId] + ".chunk.js";
};